import { morph, MORPH_OPTIONS } from '@theme/morph';

document.addEventListener('click', function(e) {
  var link = e.target.closest('a.flavor-card');
  if (!link || link.classList.contains('flavor-card--active')) return;

  e.preventDefault();
  var url = link.href;

  link.style.opacity = '0.5';

  fetch(url)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newMain = doc.querySelector('main');
      var oldMain = document.querySelector('main');
      if (newMain && oldMain) {
        morph(oldMain, newMain);
        document.dispatchEvent(new CustomEvent('flavor:changed'));
      }
      document.title = doc.title;
      history.pushState({}, '', url);
    })
    .catch(function() {
      window.location.href = url;
    });
});

window.addEventListener('popstate', function() {
  fetch(location.href)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newMain = doc.querySelector('main');
      var oldMain = document.querySelector('main');
      if (newMain && oldMain) {
        morph(oldMain, newMain);
        document.dispatchEvent(new CustomEvent('flavor:changed'));
      }
      document.title = doc.title;
    });
});
